import { motion } from "framer-motion";
import CardContent from "../components/CardContent";
import Card from "../components/Card";
import { useState } from "react";
import ImgModal from "../components/ImgModal";
import { Folder } from "lucide-react";

const projectsData = [
    {
        title: "Espos Detailing",
        img: "/imgs/espos.png",
        desc: "A website advertising Espos Detailing, a car detailing business, complete with a contact form delivered via AWS Lambda",
        link: "http://www.esposdetailing.com",
        arch: "/imgs/coming-soon.jpg",
    }
];

function Projects() {
    const [open, setOpen] = useState({});

    const handleClick = (imgSrc) => {
        setOpen({ "open": true, "imgSrc": imgSrc });
    }

    return (
        <div className="py-12 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4">
                <h2 className="text-3xl font-bold mb-2 flex items-center gap-2">
                    <Folder /> Projects
                </h2>
                <h3 className="text-xl mb-8 flex items-center gap-2">
                    Feel free to reach out if you have any questions or want to talk about how something was built!
                </h3>
                <div className="grid lg:grid-cols-3 gap-8">
                    {projectsData.map((proj, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            style={{height: 'fit-content'}}
                            className="bg-white rounded-2xl shadow-xl overflow-hidden"
                        >
                            <img onClick={ () => handleClick(proj.img) } src={proj.img} alt={proj.title} className="w-full h-40 object-cover small" />
                            <Card>
                                <CardContent className="flex flex-col gap-3">
                                    <h3 className="text-xl font-semibold">{proj.title}</h3>
                                    <p className="text-gray-700">{proj.desc}</p>
                                    { proj.link && <a className="text-blue-800 underline" target="_blank" rel="noreferrer" href={proj.link}>Visit Project</a> }
                                    <div>
                                        <p className="text-gray-500 text-sm">Architecture Diagram:</p>
                                        <img onClick={ () => handleClick(proj.arch) } src={proj.arch} alt="diagram" className="border-2 border-gray-200 rounded-lg mt-2 small" />
                                    </div>
                                </CardContent>
                            </Card>
                        </motion.div>
                    ))}
                </div>
            </div>
            <ImgModal open={open} setOpen={setOpen} />
        </div>
    );
};

export default Projects;